
$(function () {
$('.footer-block--menu h2').click(function(){
  $(this).toggleClass('active_accordian');
  //$('.footer_menu_list_1').slideToggle();
    $(this).next().slideToggle();
  if($(this).hasClass('active_accordian')) {
        $(this).find('span').text('+');
   
  }else{
 $(this).find('span').text('-');
  }
});
  if(window.matchMedia("(max-width: 749px)").matches) {
    $( ".footer-block--menu h2" ).trigger( "click" );
  }

  });

$(function () {
  let owl = $(".owl-carousel.img-link-slider");
  owl.owlCarousel({
    autoplay: true,
    dots: true,
    loop: true,
    nav: false,
    margin: 20,
    responsive: {
      0: {
        items: 1.1,
        margin: 0,
      },
      768: {
        items: 3,
      },
      1200: {
        items: 4,
      },
    },
  });
});

$(function () {
  let owl = $(".owl-carousel.model-slider");
  owl.owlCarousel({
    autoplay: false,
    dots: true,
    loop: false,
    nav: false,
    margin: 0,
    responsive: {
      0: {
        items: 3,
        margin: 0,
        loop: true,
        autoplay: true
      },
      768: {
        items: 5,
      },
      1200: {
        items: 8,
      },
    },
  });
});

window.addEventListener('load', () => {
    setTimeout(function () {
  
    let owl = $(".related-prodcts");
    console.log(owl)
    owl.owlCarousel({
      autoplay: false,
      dots: true,
      loop: false,
      nav: false,
      margin: 0,
      responsive: {
        0: {
          items: 1.7,
          margin: 0,
          loop: true,
          autoplay: true
        },
        768: {
          items: 3,
        },
        1200: {
          items: 4,
        },
      },
    });
    },2500);
})

/********************/

$(function () {
  let owl = $(".owl-carousel.testi-slider");
  owl.owlCarousel({
    autoplay: true,
    // animateOut: 'slideOutUp',
    // animateIn: 'slideInUp',
    dots: true,
    loop: true,
    nav: false,
    margin: 0,
    DragEvent: false,
    autoHeight:true,
    responsive: {
      0: {
        items: 1.1,
        margin: 0,
      },
      768: {
        items: 3,
      },
      1200: {
        items: 3,
      },
    },
  });
});

/************************/

/**********thumb slider*************/

$(document).ready(function () {
  let sync1 = $("#sync1");
  let sync2 = $("#sync2");
  let slidesPerPage = 6;
  let syncedSecondary = true;

  sync1
    .owlCarousel({
      items: 1,
      slideSpeed: 2000,
      nav: false,
      autoplay: false,
      dots: true,
      loop: true,
      responsiveRefreshRate: 200,
      navText: [
        '<svg width="100%" height="100%" viewBox="0 0 11 20"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M9.554,1.001l-8.607,8.607l8.607,8.606"/></svg>',
        '<svg width="100%" height="100%" viewBox="0 0 11 20" version="1.1"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M1.054,18.214l8.606,-8.606l-8.606,-8.607"/></svg>',
      ],
    })
    .on("changed.owl.carousel", syncPosition);

  sync2
    .on("initialized.owl.carousel", function () {
      sync2.find(".owl-item").eq(0).addClass("current");
    })
    .owlCarousel({
      items: slidesPerPage,
      dots: true,
      nav: false,
      smartSpeed: 200,
      slideSpeed: 500,
      slideBy: slidesPerPage,
      responsiveRefreshRate: 100,
    })
    .on("changed.owl.carousel", syncPosition2);

  function syncPosition(el) {
    let count = el.item.count - 1;
    let current = Math.round(el.item.index - el.item.count / 2 - 0.5);

    if (current < 0) {
      current = count;
    }
    if (current > count) {
      current = 0;
    }

    //end block

    sync2
      .find(".owl-item")
      .removeClass("current")
      .eq(current)
      .addClass("current");
    let onscreen = sync2.find(".owl-item.active").length - 1;
    let start = sync2.find(".owl-item.active").first().index();
    let end = sync2.find(".owl-item.active").last().index();

    if (current > end) {
      sync2.data("owl.carousel").to(current, 100, true);
    }
    if (current < start) {
      sync2.data("owl.carousel").to(current - onscreen, 100, true);
    }
  }

  function syncPosition2(el) {
    if (syncedSecondary) {
      let number = el.item.index;
      sync1.data("owl.carousel").to(number, 100, true);
    }
  }

  sync2.on("click", ".owl-item", function (e) {
    e.preventDefault();
    let number = $(this).index();
    sync1.data("owl.carousel").to(number, 300, true);
  });
});

/*************faq****************** */

let acc = document.getElementsByClassName("accordion");
let i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    let panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

/* new code */

/*************tabs*********** */

// tabs

let tabLinks = document.querySelectorAll(".tablinks");
let tabContent = document.querySelectorAll(".tabcontent");

tabLinks.forEach(function (el) {
  el.addEventListener("click", openTabs);
});

function openTabs(el) {
  let btnTarget = el.currentTarget;
  let country = btnTarget.dataset.country;
  const tabContent = btnTarget.parentElement.parentElement.querySelectorAll(".tabcontent");
  tabContent.forEach(function (el) {
    el.classList.remove("active");
  });

  tabLinks.forEach(function (el) {
    el.classList.remove("active");
  });

  document.querySelector("#" + country).classList.add("active");

  btnTarget.classList.add("active");
}

/**********first slide**********/

$(function () {
  let owl = $(".owl-carousel.first-slider_1");
  owl.owlCarousel({
    autoplay: false,
    // animateOut: 'slideOutUp',
    // animateIn: 'slideInUp',
    dots: true,
    loop: true,
    nav: false,
    margin: 0,
    DragEvent: true,
    responsive: {
      0: {
        items: 1.1,
      },
      767: {
        items: 2,
      },
      992: {
        items: 3,
      },
      1200: {
        items: 4,
      },
    },
  });
});

$(function () {
  let owl = $(".owl-carousel.first-slider_2");
  owl.owlCarousel({
    autoplay: false,
    // animateOut: 'slideOutUp',
    // animateIn: 'slideInUp',
    dots: true,
    loop: true,
    nav: false,
    margin: 0,
    DragEvent: true,
    responsive: {
      0: {
        items: 1.1,
      },
      767: {
        items: 2,
      },
      992: {
        items: 3,
      },
      1200: {
        items: 4,
      },
    },
  });
});

$(function () {
  let owl = $(".owl-carousel.first-slider_3");
  owl.owlCarousel({
    autoplay: false,
    // animateOut: 'slideOutUp',
    // animateIn: 'slideInUp',
    dots: true,
    loop: true,
    nav: false,
    margin: 0,
    DragEvent: true,
    responsive: {
      0: {
        items: 1.1,
      },
      767: {
        items: 2,
      },
      992: {
        items: 3,
      },
      1200: {
        items: 4,
      },
    },
  });
});

$(function () {
  let owl = $(".owl-carousel.first-slider_4");
  owl.owlCarousel({
    autoplay: false,
    // animateOut: 'slideOutUp',
    // animateIn: 'slideInUp',
    dots: true,
    loop: true,
    nav: false,
    margin: 0,
    DragEvent: true,
    responsive: {
      0: {
        items: 1.1,
      },
      767: {
        items: 2,
      },
      992: {
        items: 3,
      },
      1200: {
        items: 4,
      },
    },
  });
});

/************************/


/************************************ */

$(function () {
  let owl = $(".owl-carousel.banner-slider-img-text");
  owl.owlCarousel({
    autoplay: false,
    // animateOut: 'slideOutUp',
    // animateIn: 'slideInUp',
    dots: true,
    loop: true,
    nav: false,
    margin: 0,
    DragEvent: true,
    responsive: {
      0: {
        items: 1,
      },
    },
  });
});


/************************************ */

$(function () {
  let owl = $(".owl-carousel.text-img-slider");
  owl.owlCarousel({
    autoplay: false,

     animateOut: 'slideOutUp',
     animateIn: 'slideInUp',
    dots: true,
    loop: true,
    nav: false,
    margin: 0,
    DragEvent: true,
    responsive: {
      0: {
        items: 1,
      },
    },
  });
});

/**************drag image***************/

const scrollImg = document.querySelector(".btn-img-box");
const customSlider = document.querySelector(".custom_slider");
if (customSlider) {
  customSlider.addEventListener("input", (e) => {
    scrollImg.style.setProperty("--position", `${e.target.value}%`);
  });
}

function Marquee(selector, speed) {
  const parentSelector = document.querySelector(selector);
  if(parentSelector) {  
    const clone = parentSelector.innerHTML;
    const firstElement = parentSelector.children[0];
    let i = 0;
    console.log(firstElement);
    parentSelector.insertAdjacentHTML("beforeend", clone);
    parentSelector.insertAdjacentHTML("beforeend", clone);
    parentSelector.insertAdjacentHTML("beforeend", clone);
    parentSelector.insertAdjacentHTML("beforeend", clone);
    parentSelector.insertAdjacentHTML("beforeend", clone);
    parentSelector.insertAdjacentHTML("beforeend", clone);
    parentSelector.insertAdjacentHTML("beforeend", clone);
  
    setInterval(function () {
      firstElement.style.marginLeft = `-${i}px`;
      if (i > firstElement.clientWidth) {
        i = 0;
      }
      i = i + speed;
    }, 0);
  }
}

window.addEventListener("load", Marquee(".marquee", 0.8));

const popupContainer = document.querySelectorAll('.popup-container');

popupContainer.forEach(popup => {
  const popOpener = document.querySelectorAll(`[popup-opener="${popup.id}"]`)
  const overlay = popup.querySelector('.overlay');
  overlay.addEventListener('click', () => {
      popup.classList.remove('active')
  })
  popOpener.forEach(opener => {
    opener.addEventListener('click', () => {
      popup.classList.add('active')
    })
  })
})

$('.product-form__confirmation,.product-info_variant-confirmation_modal-close,.product-info_variant-confirmation_modal-overlay').click(function(){
  $('.product-info_variant-confirmation_modal').toggle();
});

/**************render variant color image (Backup) ***************/
// $(function () {
//   window.updateColorLabels = function() {
//     let colorElements = document.querySelectorAll('input[name="Color"]:not(.disabled)');
//     let colorOptionMaterial = document.querySelector('[data-selected-swatch-value="Material"]').innerText;
//     for (var colorElI = 0, element; element = colorElements[colorElI]; colorElI++) {
//       let colorOptionAltText = colorOptionMaterial + "-" + colorElements[colorElI].value;
//       try{
//         let colorOptionURL = window.variantImages.find(it => it.alt === colorOptionAltText).src;
//         colorElements[colorElI].labels[0].style.backgroundImage = "url(" + colorOptionURL + ")";
//       } catch(e) {}
//     }
//   }
//   if(document.querySelector('input[name="product-handle"]')) {
//     if(!window.variantImages) {
//       let variantImageAPIsettings = {
//         "url": "/products/" + document.querySelector('input[name="product-handle"]').value + ".json",
//         "method": "GET",
//       };
//       $.ajax(variantImageAPIsettings).done(function (response) {
//         window.variantImages = response.product.images;
//         window.updateColorLabels();
//       });
//     }
//     else{
//       window.updateColorLabels();
//     }
//   }
// });

/**************render variant color image***************/
// Define function globally first to prevent "not a function" errors
// This ensures it's available even if called before jQuery is ready
window.updateColorLabels = function() {
  try {
    let colorElements = document.querySelectorAll('input[name="Color"]:not(.disabled)');
    if (!colorElements || colorElements.length === 0) return;
    
    let materialElement = document.querySelector('[data-selected-swatch-value="Material"]');
    if (!materialElement) return;
    
    let colorOptionMaterial = materialElement.innerText;
    if (!window.variantImages || !Array.isArray(window.variantImages)) return;
    
    for (var colorElI = 0, element; element = colorElements[colorElI]; colorElI++) {
      let colorOptionAltText = colorOptionMaterial + "-" + colorElements[colorElI].value;
      try{
        let matchingImage = window.variantImages.find(it => it.alt === colorOptionAltText);
        if (matchingImage && matchingImage.src && colorElements[colorElI].labels && colorElements[colorElI].labels[0]) {
          colorElements[colorElI].labels[0].style.backgroundImage = "url(" + matchingImage.src + ")";
        }
      } catch(e) {
        // Silently fail for individual label updates
      }
    }
  } catch(e) {
    // Silently fail if function can't execute (e.g., dependencies not ready)
  }
};

$(function () {
  console.log('called in custom.js $(function ()');
  if(document.querySelector('input[name="product-handle"]')) {
    if(!window.variantImages) {
      let variantImageAPIsettings = {
        "url": "/products/" + document.querySelector('input[name="product-handle"]').value + ".json",
        "method": "GET",
      };
      $.ajax(variantImageAPIsettings).done(function (response) {
        window.variantImages = response.product.images;
        console.log('called in custom.js if case');
        if (typeof window.updateColorLabels === 'function') {
          window.updateColorLabels();
        }
      });
    }
    else{
      console.log('called in custom.js else case');
      if (typeof window.updateColorLabels === 'function') {
        window.updateColorLabels();
      }
    }
  }
});
